<div class="app-sidebar bg-color-light padding-top" (click)="openSidebarMenu()">
  <section class="sidebar-content">
    <ul class="nav">
      <!-- Links for everyone -->

      <!-- Dashboard -->
      <li class="active">
        <a mat-button class="mat-button-wrapper" [routerLink]="['/dashboard']" (click)="closeSidebarMenu()">
          <mat-icon class="nav-icon">home</mat-icon>
          <span class="nav-text">{{ 'SideNav.Dashboard' | translate }}</span>
        </a>
      </li>

      <!-- Profile -->
      <li class="active">
        <a mat-button class="mat-button-wrapper" [routerLink]="['/profile']" (click)="closeSidebarMenu()">
          <mat-icon class="nav-icon">person</mat-icon>
          <span class="nav-text">{{ 'SideNav.Profile' | translate }}</span>
        </a>
      </li>

      <!-- Certifications -->
      <ng-container *hasRole="[Roles.candidate]">
        <li class="active">
          <a
            mat-button
            class="mat-button-wrapper"
            [routerLink]="['/profile']"
            [queryParams]="{ tab: 1 }"
            (click)="closeSidebarMenu()"
          >
            <mat-icon class="nav-icon">class</mat-icon>
            <span class="nav-text">{{ 'SideNav.Certifications' | translate }}</span>
          </a>
        </li>
      </ng-container>

      <!-- Security -->
      <li class="active">
        <a
          mat-button
          class="mat-button-wrapper"
          [routerLink]="['/profile']"
          [queryParams]="{ tab: 2 }"
          (click)="closeSidebarMenu()"
        >
          <mat-icon class="nav-icon">vpn_key</mat-icon>
          <span class="nav-text">{{ 'SideNav.Security' | translate }}</span>
        </a>
      </li>

      <li class="nav-divider"></li>

      <!-- Links for Candidates, Evaluator and third parties  -->
      <ng-container *ngIf="isDoneRegister">
        <ng-container *hasRole="[Roles.candidate, Roles.evaluator, Roles.thirdParty]">
          <!-- Email History -->
          <!-- <li class="active">
            <a
              mat-button
              class="mat-button-wrapper enotification"
              [routerLink]="['/dashboard/notification-log-viewer']"
              (click)="closeSidebarMenu()"
            >
              <span *ngIf="unreadEmailCount > 0" class="notebadge">{{ unreadEmailCount }}</span>
              <mat-icon class="nav-icon">email</mat-icon>

              <span class="nav-text">{{ 'SideNav.EmailHistory' | translate }}</span>
            </a>
          </li> -->

          <!-- Announcements (Messages that pop up for all users) -->
          <!-- <li class="active">
            <a
              mat-button
              class="mat-button-wrapper"
              [routerLink]="['/dashboard/communication-viewer']"
              (click)="closeSidebarMenu()"
            >
              <img class="nav-icon material-icons" src="assets/images/campaign.svg" />
              <span class="nav-text">{{ 'Communications.CommunicationsHistoryTitle' | translate }}</span>
            </a>
          </li> -->
        </ng-container>
      </ng-container>

      <!-- Links for Administrators, Evaluators and Third Parties -->
      <ng-container>
        <!-- Certifications -->
        <li class="active" *hasRole="[Roles.admin, Roles.evaluator]">
          <a
            mat-button
            class="mat-button-wrapper"
            [routerLink]="['/admin/certifications']"
            (click)="closeSidebarMenu()"
          >
            <mat-icon class="nav-icon">class</mat-icon>
            <span class="nav-text">{{ 'SideNav.Certifications' | translate }}</span>
          </a>
        </li>

        <!-- Tests  -->
        <li class="active" *hasRole="[Roles.admin, Roles.evaluator]">
          <a mat-button class="mat-button-wrapper" [routerLink]="['/admin/tests']" (click)="closeSidebarMenu()">
            <mat-icon class="nav-icon">assignment</mat-icon>
            <span class="nav-text">{{ 'SideNav.Tests' | translate }}</span>
          </a>
        </li>

        <!-- Users -->
        <li class="active" *hasRole="[Roles.admin, Roles.evaluator, Roles.thirdParty]">
          <a mat-button class="mat-button-wrapper" [routerLink]="['/admin/users']" (click)="closeSidebarMenu()">
            <mat-icon class="nav-icon">account_box</mat-icon>
            <span class="nav-text">{{ 'SideNav.Users' | translate }}</span>
          </a>
        </li>

        <!-- Announcements -->
        <li class="active" *hasRole="[Roles.admin]">
          <a
            mat-button
            class="mat-button-wrapper"
            [routerLink]="['/admin/communications']"
            (click)="closeSidebarMenu()"
          >
            <mat-icon class="nav-icon">campaign</mat-icon>
            <!-- <img
              class="nav-icon material-icons"
              src="assets/images/campaign.svg"
            /> -->
            <span class="nav-text">{{ 'Communications.SearchTitle' | translate }}</span>
          </a>
        </li>

        <!-- Emails  -->
        <li class="active" *hasRole="[Roles.admin]">
          <a
            mat-button
            class="mat-button-wrapper"
            [routerLink]="['/admin/user-notifications']"
            (click)="closeSidebarMenu()"
          >
            <mat-icon class="nav-icon">email</mat-icon>
            <span class="nav-text">{{ 'SideNav.Notifications' | translate }}</span>
          </a>
        </li>

        <!-- Group Examinations -->
        <li class="active" *hasRole="[Roles.admin, Roles.thirdParty]">
          <a mat-button class="mat-button-wrapper" [routerLink]="['/admin/groups']" (click)="closeSidebarMenu()">
            <mat-icon class="nav-icon">groups</mat-icon>
            <span class="nav-text">{{ 'Groups.Title' | translate }}</span>
          </a>
        </li>

        <!-- Evaluator Admin  -->
        <li class="active" *hasRole="[Roles.admin]" hidden>
          <a
            mat-button
            class="mat-button-wrapper"
            [routerLink]="['/evaluator/admin']"
            (click)="closeSidebarMenu()"
          >
            <!-- <mat-icon class="nav-icon">manage_accounts</mat-icon> -->
            <img class="icon" src="assets/icons/manage_accounts_black_24dp.svg"/>
            <span class="nav-text">{{ 'Evaluators.Admin.Title' | translate }}</span>
          </a>
        </li>

        <!-- Evaluator Availability Calendar  -->
        <li class="active" *hasRole="[Roles.admin, Roles.evaluator]" hidden>
          <a
            mat-button
            class="mat-button-wrapper"
            [routerLink]="['/evaluator/availability']"
            (click)="closeSidebarMenu()"
          >
            <mat-icon class="nav-icon">event</mat-icon>
            <span class="nav-text">{{ 'Evaluators.AvailabilityCalendar.Title' | translate }}</span>
          </a>
        </li>

        <!-- Evaluator - Assigned Candidates  -->
        <li class="active" *hasRole="[Roles.admin, Roles.evaluator]" hidden>
          <a
            mat-button
            class="mat-button-wrapper"
            [routerLink]="['/evaluator/assigned-candidates']"
            (click)="closeSidebarMenu()"
          >
            <mat-icon class="nav-icon">assignment_ind</mat-icon>
            <span class="nav-text">{{ 'Evaluators.AssignedCandidates.Title' | translate }}</span>
          </a>
        </li>
      </ng-container>
    </ul>
  </section>
  <section class="sidebar-footer">
    <ul class="nav">
      <li class="active">
        <a mat-button class="mat-button-wrapper" (click)="commonDialogService.showContact()" (click)="closeSidebarMenu()">
          <mat-icon class="nav-icon">help</mat-icon>
          <span class="nav-text">{{ 'SideNav.Help' | translate }}</span>
        </a>
      </li>
    </ul>
  </section>
</div>
